import axiosClient from '../axiosClient';
import { GateEndpoints } from '../endpoints/gate';
import { GateScanResponse, GateAdmitResponse } from '../../types/api/response/gateresponse';

export const GateService = {
  async scan(gateToken: string): Promise<GateScanResponse> {
    const res = await axiosClient.post<GateScanResponse>(GateEndpoints.SCAN, {
      gate_token: gateToken,
    });
    return res.data;
  },

  async admit(gateToken: string): Promise<GateAdmitResponse> {
    const res = await axiosClient.post<GateAdmitResponse>(GateEndpoints.ADMIT, {
      gate_token: gateToken,
    });
    return res.data;
  },
};
